export default {
    common: {
        appName: 'Swift Invoice',
        cancel: 'Cancel',
        email: 'Email',
        password: 'Password',
        or: 'or',
        change: 'Change',
        delete: 'Delete',
        save: 'Save',
        edit: 'Edit',
        add: 'Add',
        close: 'Close',
        date: 'Date',
        total: 'Total',
        status: 'Status',
        amount: 'Amount',
        quantity: 'Quantity',
        rate: 'Rate',
        tax: 'Tax',
        discount: 'Discount',
        note: 'Note',
        notes: 'Notes',
        description: 'Description',
        client: 'Client',
        item: 'Item',
        items: 'Items',
        type: 'Type',
        category: 'Category',
        phone: 'Phone',
        name: 'Name',
        subject: 'Subject',
        saveAndClose: 'Save and Close',
        saveAndSendEmail: 'Save and Send Email',
        sendEmail: 'Send email',
        send: 'Send',
        print: 'Print',
        moreActions: 'More actions',
        preparingPdf: 'Preparing PDF...',
        pdfPreparationFailed: 'Unable to prepare PDF',
        warning: 'Warning',
        ok: 'OK',
        uploadSuccess: 'upload success',
        saveSuccess: 'save success',
        deleteSuccess: 'delete success',
        deleteFailed: 'delete failed',
        saveFailed: 'save failed',
        loadFailed: 'load failed',
        systemError: 'system error',
        sendSuccess: 'send success',
        updateSuccess: 'update success',
        unsavedChangesMsg: 'You have unsaved changes. Would you like to save or discard them?',
        saveChangesTitle: 'Save changes?',
        confirmSave: 'Save',
        discard: 'Discard',
        validEmail: 'Please enter a valid email address',
        deleteFailedMsg: 'delete failed',
        shipping: 'Shipping',
        attachment: 'Attachment',
        days: 'Days',
        excl: '(excl.)',
        incl: '(incl.)',
        of: 'of'
    },
    login: {
        heroPrefix: 'Smart ',
        heroInvoicing: 'Invoicing',
        heroMiddle: ',',
        heroSimplified: 'Simplified',
        heroSuffix: ' for You.',
        subtitle1: 'Create, send, and manage invoices effortlessly.',
        subtitle2: 'Get paid faster with Swift Invoice.',
        feature1Title: 'Professional Invoices',
        feature1Text: 'Create beautiful invoices in minutes',
        feature2Title: 'Real-time Tracking',
        feature2Text: 'Track payments and invoice status',
        feature3Title: 'Secure & Reliable',
        feature3Text: 'Your data is safe with enterprise-grade security',
        welcomeBack: 'Welcome back',
        signInToContinue: 'Sign in to your account to continue',
        enterEmail: 'Enter your email',
        enterPassword: 'Enter your password',
        rememberMe: 'Remember me',
        forgotPassword: 'Forgot password?',
        signIn: 'Sign in',
        signingIn: 'Signing in…',
        continueWithGoogle: 'Continue with Google',
        continueWithApple: 'Continue with Apple',
        createAccount: 'Create account',
        startUsing: 'Start using Swift Invoice',
        companyName: 'Company name',
        enterCompanyName: 'Enter your company name',
        alreadyHaveAccount: 'Already have an account? Sign in',
        footerRights: '© 2026 Swift Invoice. All rights reserved.',
        termsOfService: 'Terms of Service',
        contactUs: 'Contact us: goodinvoicego@gmail.com',
        betaDialogBody: 'Our team completed the first version of the web <br> This version will only be available to iPhone users <br> We will improve the web function as soon as possible and open it to all <br>',
        ieDialogBody: 'Sorry, because IE browser has compatibility problems, we do not support IE browser at present, if you need to use, please download',
        resetPasswordTitle: 'Reset password',
        sendResetEmail: 'Send reset email',
        resetEmailSent: 'Reset password email sent. Please check your inbox.',
        bindingTitle: 'Link existing account',
        bindingHintPrefix: 'An account already uses the email ',
        bindingHintSuffix: ". Enter that account's password to link your Google sign-in.",
        enterAccountPassword: 'Enter account password',
        linkAccount: 'Link account',
        validEmail: 'Please enter a valid email address',
        validPassword: 'Password must be 6 characters or more',
        validCompanyName: 'Please fill in your company name'
    },
    account: {
        title: 'Account',
        profile: 'Profile',
        swiftAccount: 'Swift Invoice account',
        connectSocial: 'Connect social accounts',
        companyLogo: 'Company logo',
        addLogo: 'Add logo',
        uploading: 'uploading...',
        currentPlan: 'Current plan: Swift {plan}',
        planActiveUntil: 'Plan active until {date}',
        sharedWithMobile: 'Shared with mobile',
        subscriptionExpired: 'Your subscription has expired',
        planNote: 'Log in again if your subscription status has not been updated.',
        upgradeToPro: 'Upgrade to Swift Pro',
        viewPlans: 'View subscription plans',
        connecting: 'Connecting…',
        connectGoogle: 'Connect Google',
        googleConnected: 'Google connected',
        googleConnectedWithEmail: 'Google connected ({email})',
        connectApple: 'Connect Apple',
        appleConnected: 'Apple connected',
        appleConnectedWithEmail: 'Apple connected ({email})',
        logoUuidMissing: 'Company logo UUID is missing',
        googleConnectedToast: 'Google account connected.',
        appleConnectedToast: 'Apple account connected.'
    },
    menu: {
        invoices: 'Invoices',
        estimates: 'Estimates',
        purchaseOrders: 'Purchase Orders',
        creditMemos: 'Credit Memos',
        time: 'Time',
        items: 'Items',
        clients: 'Clients',
        expenses: 'Expenses',
        reports: 'Reports',
        settings: 'Settings',
        companyInfo: 'Company info',
        taxes: 'Taxes',
        default: 'Default',
        customizeInvoice: 'Customize invoice',
        sendFeedback: 'Send Feedback',
        newReply: '1 new reply',
        signOut: 'Sign out',
        signOutConfirm: 'Are you sure sign out?',
        addBusiness: 'Add business',
        newBusinessTitle: 'New business',
        businessName: 'Business name',
        businessNamePlaceholder: 'Enter the business name',
        createBusiness: 'Create',
        businessNameRequired: 'Enter the business name',
        createBusinessSuccess: 'Business created successfully'
    },
    network: {
        loginExpired: 'Login expired, please log in again',
        requestTimeout: 'Request timed out, please check the network'
    },
    language: {
        label: 'Language',
        zh: '中文',
        en: 'English'
    },
    invoice: {
        searchPlaceholder: 'Search your invoices',
        addInvoice: 'Add invoice',
        overdueInvoices: 'Overdue invoices',
        paidInvoices: 'Paid invoices',
        unpaidInvoices: 'Unpaid invoices',
        unsentInvoices: 'Unsent invoices',
        columnNumber: 'Number',
        columnClient: 'Client',
        columnStatus: 'Status',
        statusFullyPaid: 'Fully paid',
        statusPartial: 'Partial',
        statusOverdue: 'Overdue',
        statusUnsent: 'UnSent',
        statusSent: 'Sent',
        statusOpened: 'Opened',
        actionRecordPayment: 'Record Payment',
        actionMarkAsSent: 'Mark as Sent',
        actionCopy: 'Copy',
        actionDelete: 'Delete',
        copyDialogTitle: 'Copy invoice',
        copyTargetType: 'Copy to',
        copyOptions: 'Copy options',
        copyClient: 'Copy client',
        copyItems: 'Copy items',
        copyAttachments: 'Copy attachments',
        confirmDelete: 'This will delete the invoice. Continue?',
        copySuccess: 'Invoice copied',
        copyFailed: 'Copy failed',
        deleteSuccess: 'Invoice deleted',
        deleteFailed: 'Delete failed',
        recordPaymentDialogTitle: 'Record Payment',
        markAsFullyPaid: 'Mark as fully paid',
        formAmount: 'Amount',
        formDate: 'Date',
        formPaymentMethod: 'Payment Method',
        formNote: 'Note',
        allYears: 'All years',
        errorMorePaymentThanBalanceDue: 'More payment than balance due',
        errorAmountMustBeGreaterThanZero: 'The amount must be greater than zero',
        dueDateToday: 'Today',
        dueDateDaysAgo: '{days} days ago',
        dueDateInDays: 'in {days} days'
    },
    estimate: {
        pageTitlePurchaseOrders: 'Purchase Orders',
        pageTitleEstimates: 'Estimates',
        pageTitleCreditMemos: 'Credit Memos',
        searchPlaceholderPurchaseOrders: 'Search your purchase orders',
        searchPlaceholderEstimates: 'Search your estimates',
        searchPlaceholderCreditMemos: 'Search your credit memos',
        addPurchaseOrder: 'Add purchase order',
        addEstimate: 'Add estimate',
        addCreditMemo: 'Add credit memo',
        columnNumber: 'Number',
        columnClient: 'Client',
        columnDate: 'Date',
        columnEmail: 'Email',
        columnStatus: 'Status',
        columnTotal: 'Total',
        statusUnsent: 'Unsent',
        statusSent: 'Sent',
        actionMarkAsSent: 'Mark as Sent',
        actionCopy: 'Copy',
        actionDelete: 'Delete',
        actionConvertToInvoice: 'Convert to Invoice',
        copyDialogTitle: 'Copy {document}',
        copyTargetType: 'Copy to',
        copyOptions: 'Copy options',
        copyClient: 'Copy client',
        copyItems: 'Copy items',
        copyAttachments: 'Copy attachments',
        confirmDelete: 'This will delete the {document}. Continue?',
        convertConfirm: 'Convert this {document} to an invoice? The issue date will be set to today.',
        copySuccess: '{document} copied',
        copyFailed: 'Copy failed',
        convertSuccess: '{document} converted to invoice',
        convertFailed: 'Convert failed',
        deleteSuccess: '{document} deleted',
        deleteFailed: 'Delete failed',
        dueDateToday: 'Today',
        dueDateDaysAgo: '{days} days ago',
        dueDateInDays: 'in {days} days'
    },
    item: {
        pageTitle: 'Items',
        searchPlaceholder: 'Search your items',
        addItem: 'Add item',
        columnInventoryCountUnit: 'Inventory Count/Unit'
    },
    client: {
        pageTitle: 'Clients',
        searchPlaceholder: 'Search your clients',
        addClient: 'Add client',
        columnClientName: 'Client Name',
        columnEmail: 'Email',
        columnPhone: 'Phone',
        columnBalanceDue: 'Balance Due',
        noNameFallback: 'NO NAME'
    },
    expense: {
        pageTitle: 'Expenses',
        searchPlaceholder: 'Search your expenses',
        addExpense: 'Add expense',
        columnDescription: 'Description',
        columnDate: 'Date',
        columnTotal: 'Total'
    },
    report: {
        headerTitle: 'Reports',
        tabDashboard: 'Dashboard',
        tabReportList: 'Report list',
        export: 'Export',
        annualSalesByClient: 'Annual sales by client',
        totalOutstandingBalance: 'Total outstanding balance',
        invoicesCountSuffix: 'invoices',
        byMonth: 'By month',
        byQuarter: 'By quarter',
        noSalesFound: 'No sales found',
        filterReportTypes: 'Report types',
        filterTimePeriod: 'Time period',
        filterView: 'View',
        optionMonthly: 'Monthly',
        optionQuarterly: 'Quarterly',
        customerAgingTitle: 'Customer Aging',
        noDataForDateRange: 'No data for this date range',
        typeSalesByDate: 'Sales by Date',
        typeSalesByClient: 'Sales by Client',
        typeSalesByItem: 'Sales by Item',
        typeSalesJournal: 'Sales Journal',
        typePaymentsByDate: 'Payments by Date',
        typePaymentsByClient: 'Payments by Client',
        typePaymentsByType: 'Payments by Type',
        typePaymentsJournal: 'Payments Journal',
        typeExpenseByCategory: 'Expense by Category',
        typeExpenseJournal: 'Expense Journal',
        typeCustomerAging: 'Customer Aging',
        allYears: 'All years',
        allTime: 'All time',
        allSales: 'All sales',
        taxYearSales: 'Tax year {year} sales',
        firstColumnMonth: 'Month',
        firstColumnQuarter: 'Quarter',
        columnSubTotal: 'Sub Total',
        columnTax: 'Tax',
        columnDiscount: 'Discount',
        columnTotal: 'Total',
        columnAmountPaid: 'Amount Paid',
        columnAmountOwed: 'Amount Owed',
        columnClient: 'Client',
        columnItem: 'Item',
        columnUnitType: 'Unit Type',
        columnQuantity: 'Quantity',
        columnRateAvg: 'Rate (avg)',
        columnInvoiceDate: 'Invoice Date',
        columnInvoiceNo: 'Invoice No',
        columnType: 'Type',
        columnPaymentDate: 'Payment Date',
        columnCategory: 'Category',
        columnExpenseDate: 'Expense Date',
        columnMerchant: 'Merchant',
        columnDescription: 'Description',
        columnCurrentDue: 'Current Due',
        column1To30DaysOverdue: '1-30 Days Overdue',
        column31To60DaysOverdue: '31-60 Days Overdue',
        column61To90DaysOverdue: '61-90 Days Overdue',
        column91PlusDaysOverdue: '91+ Days Overdue',
        monthNames: 'Jan, Feb, Mar, Apr, May, Jun, Jul, Aug, Sep, Oct, Nov, Dec',
        totalRowLabel: 'Total'
    },
    invoiceCreate: {
        pageTitlePrefix: 'Add',
        invoicePrefix: 'invoice prefix',
        tabCreate: 'Create',
        tabPreview: 'Preview',
        tabSendEmail: 'Send Email',
        sectionClient: 'Client',
        addClient: 'Add client',
        dialogClientInfo: 'Client information',
        basicInformation: 'Basic information',
        labelName: 'Name',
        labelEmail: 'Email',
        labelPhone: 'Phone',
        billingAddress: 'Billing address',
        labelLine1: 'Line 1',
        labelLine2: 'Line 2',
        labelLine3: 'Line 3',
        shippingAddress: 'Shipping address',
        labelShippingName: 'Shipping Name',
        labelNotes: 'Notes',
        placeholderCreateOrSelect: 'Create or select one...',
        placeholderClientNotes: "Add notes about the client. They can't see these",
        sectionItems: 'Items',
        saveToYourItem: 'Save to your item',
        stock: 'Stock:',
        placeholderItemCode: 'item code',
        placeholderQuantity: 'Quantity',
        placeholderRate: 'rate',
        placeholderInputDescription: 'Input description',
        placeholderInputComment: 'Input Comment',
        placeholderAddRecipient: 'Add recipient',
        cc: 'Cc',
        bcc: 'Bcc',
        placeholderEmailSubject: 'Email subject',
        placeholderMessage: 'Write your message...',
        labelTo: 'To',
        labelSubject: 'Subject',
        sectionAttachments: 'Attachments',
        sectionComment: 'Comment',
        addItem: 'Add item',
        addPhoto: 'Add photo',
        addPayment: 'Add payment',
        goBack: 'go back',
        dialogShippingInfo: 'Shipping info',
        dialogRecordPayment: 'Record Payment',
        dialogJobDetails: 'Job details',
        labelAmount: 'Amount',
        labelShipDate: 'Ship date',
        labelShipVia: 'Ship via',
        labelTrackingNumber: 'Tracking number',
        labelFob: 'FOB',
        columnDate: 'Date',
        columnType: 'Type',
        msgClientEmailError: 'client email error',
        msgAmountGreaterThanZero: 'The amount must be greater than zero',
        msgMorePaymentThanBalance: 'More payment than balance due',
        mailSentSuccessfully: 'Mail sent successfully',
        cumulativeTaxNotice: 'Web does not support the accumulation of tax in the invoice...',
        numberLogicNotice: 'We recently changed the number logic. If your number is incorrect, edit it here. You can also go to Settings > Customize Invoice > Next Number and set Numbering begins at to the number you want.',
        confirmUnsavedChanges: 'You have unsaved changes. Would you like to save or discard them?',
        pdf: 'PDF',
        taxDiscountWithholding: 'Tax,discount and withholding',
        purchaseOrder: 'Purchase Order',
        placeholderPurchaseOrderPrefix: 'purchase order prefix',
        placeholderCreditMemoPrefix: 'credit memo prefix',
        placeholderEstimatePrefix: 'estimate prefix',
        labelStatus: 'Status',
        statusIssued: 'Issued',
        statusApproved: 'Approved',
        statusPending: 'Pending',
        statusWithdrawn: 'Withdrawn',
        tax: 'Tax'
    },
    createEstimate: {
        pageTitlePrefix: 'Add',
        cumulativeTaxNotice: 'Web does not support the accumulation of tax in the estimate...'
    },
    updateInvoice: {
        pageTitlePrefix: 'Update',
        deletePrefix: 'Delete',
        confirmDelete: 'This will delete the invoice. Continue?',
        cumulativeTaxNotice: 'This invoice contains cumulative tax. Web does not support this function temporarily'
    },
    updateEstimate: {
        pageTitlePrefix: 'Update',
        deletePrefix: 'Delete',
        confirmDelete: 'This will delete the {document}. Continue?',
        cumulativeTaxNotice: 'This estimate contains cumulative tax. Web does not support this function temporarily'
    },
    createAccount: {
        title: 'Create a Account',
        placeholderEmail: 'email',
        placeholderPassword: 'Password',
        placeholderCompanyName: 'Company Name',
        createAccountButton: 'Create account',
        alreadyHaveAccount: 'Already have an account?',
        signIn: 'Sign in',
        validEmail: 'Please enter a valid email address',
        validPassword: 'Password must be 6 characters or more',
        validCompanyName: 'Please fill in your company name'
    },
    clientCreate: {
        pageTitle: 'Add client',
        basicInformation: 'Basic information',
        labelName: 'Name',
        placeholderName: 'Enter a name...',
        labelEmail: 'Email',
        placeholderEmail: 'Enter an email address...',
        labelPhone: 'Phone',
        placeholderPhone: 'Enter a phone number...',
        billingAddress: 'Billing address',
        labelLine1: 'Line 1',
        labelLine2: 'Line 2',
        labelLine3: 'Line 3',
        shippingAddress: 'Shipping address',
        sameAsBilling: 'Same as billing address',
        labelShippingName: 'Shipping name',
        labelShippingLine1: 'Line 1',
        labelShippingLine2: 'Line 2',
        labelShippingLine3: 'Line 3',
        labelNotes: 'Notes',
        placeholderNotes: "Add notes about the client. They can't see these",
        validEmail: 'Please enter a valid email address'
    },
    clientUpdate: {
        pageTitle: 'Update client',
        confirmDelete: 'This will delete the client. Continue?'
    },
    itemCreate: {
        pageTitle: 'Add item',
        itemTitle: 'Item',
        labelCost: 'Cost',
        labelUnit: 'Unit',
        placeholderUnit: 'Unit',
        defaultTaxes: 'Default taxes',
        taxOff: 'off',
        inventoryTitle: 'Inventory',
        currentInventory: 'Current inventory',
        adjustInventory: 'Adjust inventory',
        placeholderQuantity: 'Quantity',
        placeholderDateAndTime: 'Date and time',
        placeholderNote: 'Note',
        addButton: 'Add',
        columnDate: 'Date',
        columnQuantity: 'Quantity',
        columnNote: 'Note',
        withholdingTitle: 'Withholding',
        msgInventoryCannotDisable: 'Inventory cannot be disabled after it has been enabled',
        msgDescriptionRequired: 'Item description is required',
        msgQuantityRequired: 'Quantity is required',
        msgDateRequired: 'Date and time is required'
    },
    itemUpdate: {
        pageTitle: 'Edit item',
        columnInvoice: 'Invoice',
        confirmDelete: 'This will delete the item. Continue?'
    },
    createStatement: {
        pageTitle: 'Client Statement',
        tabPreview: 'Preview',
        tabSendEmail: 'Send Email',
        createAction: 'Create Statement',
        from: 'From',
        to: 'To',
        invoices: 'Invoices',
        balanceDue: 'Balance due',
        editTitle: 'Edit Statement',
        startDate: 'Start date',
        endDate: 'End date',
        onlyShowUnpaid: 'Only show unpaid invoices',
        unpaidOnlyActive: 'This statement only includes unpaid invoices.',
        dateRequired: 'Start date and end date are required',
        invalidDateRange: 'End date must not be earlier than start date'
    },
    time: {
        pageTitle: 'Time',
        unbilled: 'Unbilled',
        billed: 'Billed',
        searchPlaceholder: 'Search time by client or description',
        addTime: 'Add time',
        noTime: 'No time entries',
        noTimeDescription: 'Create a time entry to track billable work.',
        noClient: 'No Client',
        filterAndSort: 'Filter and sort',
        year: 'Year',
        groupBy: 'Group by',
        sortBy: 'Sort by',
        order: 'Order',
        yearly: 'Yearly',
        quarterly: 'Quarterly',
        monthly: 'Monthly',
        ascending: 'Ascending',
        descending: 'Descending',
        duration: 'Duration',
        createTitle: 'Create Time',
        editTitle: 'Time',
        selectClient: 'Select a client',
        start: 'Start',
        end: 'End',
        hours: 'hours',
        minutes: 'minutes',
        ratePreset: 'Rate',
        customRate: 'Custom rate',
        rateName: 'Rate name',
        showRateName: 'Show rate name on invoice',
        endBeforeStart: 'End time must not be earlier than start time',
        invalidRate: 'Rate must be a valid number equal to or greater than zero',
        billedReadOnly: 'Billed time is linked to an invoice and cannot be changed here.',
        confirmDelete: 'This will delete the time entry. Continue?'
    },
    setting: {
        taxInfo: 'Tax Info',
        taxes: 'Taxes',
        taxYearStarts: 'Tax year starts',
        taxYearStartSubtitle: 'Set the first day of the financial year',
        rateLabel: 'Rate(%)',
        abbreviation: 'Abbreviation',
        addTax: 'Add tax',
        month: 'Month',
        day: 'Day',
        monthPlaceholder: 'Month',
        dayPlaceholder: 'Day',
        saveTaxYearStart: 'Save',
        deleteDialogTitle: 'Delete',
        confirmDeleteTax: 'Are you sure delete this tax?',
        deleteConfirm: 'Delete',
        taxInfoDialogTitle: 'Tax Info',
        taxName: 'Tax Name',
        standardRate: 'Standard rate (%)',
        additionalRate: 'Additional rate',
        deleteRateX: 'X',
        addRate: 'Add rate',
        taxType: 'Tax type',
        exclusive: 'Exclusive',
        inclusive: 'Inclusive',
        close: 'close',
        saveTax: 'Save tax',
        cantOpenDetailMessage: 'This tax contains cumulative tax. Web does not support this function temporarily',
        closeButton: 'Close',
        rateIsRequired: 'rate is must',
        rateIsRequiredMsg: 'Rate is a must',
        monthAndDayRequired: 'Month and day are required',
        moreRate: ' more rate',
        moreRates: ' more rates'
    },
    companyInfo: {
        title: 'Company Info',
        details: 'Details',
        businessName: 'Business name',
        businessNamePlaceholder: 'Business name',
        name: 'Name',
        phone: 'Phone',
        email: 'Email',
        businessNumber: 'Business Number',
        taxNo: 'Tax N°',
        deleteField: 'delete',
        addNewField: 'Add new field',
        address: 'Address',
        line1: 'Line1',
        line2: 'Line2',
        line3: 'Line3',
        currency: 'Currency',
        currencyLabel: 'Currency',
        symbol: 'Symbol',
        placement: 'Placement',
        before: 'Before',
        after: 'After',
        thousandSymbol: 'Thousand Symbol',
        decimalSymbol: 'Decimal Symbol',
        decimalPlaces: 'Decimal Places',
        example: 'Example',
        terms: 'Terms',
        termsLabel: 'Terms',
        termSameDay: 'Same Day',
        term7Days: '7 Days',
        term14Days: '14 Days',
        term21Days: '21 Days',
        term30Days: '30 Days',
        term45Days: '45 Days',
        term60Days: '60 Days',
        term90Days: '90 Days',
        term180Days: '180 Days',
        term365Days: '365 Days',
        paymentInfo: 'Payment Info',
        displayOnInvoices: 'Display on invoices',
        titlePlaceholder: 'Title',
        jobDetails: 'Job Details',
        deleteJobDetail: 'delete',
        addNewJobField: 'add new field'
    },
    default: {
        title: 'Default',
        emailMessage: 'Email Message',
        enterDescription: 'Enter a description',
        emailCc: 'Email Cc',
        emailBcc: 'Email Bcc',
        emailTip: 'Send an e-mail at the same time to the address above.',
        defaultComments: 'Default Comments',
        invoice: 'Invoice',
        estimate: 'Estimate',
        purchaseOrder: 'Purchase Order',
        creditMemo: 'Credit Memo',
        emailValidError: 'email valid'
    },
    invoiceDesign: {
        template: 'Template',
        color: 'Color',
        labels: 'Labels',
        labelInvoice: 'Invoice',
        labelEstimate: 'Estimate',
        labelPurchaseOrder: 'Purchase order',
        labelCreditMemo: 'Credit memo',
        labelReceipt: 'RECEIPT',
        labelTermsFormat: 'Terms format',
        labelBillTo: 'Bill to',
        labelFor: 'For',
        labelDate: 'Date',
        labelInvoiceNo: 'Invoice no',
        labelEstimateNo: 'Estimate no',
        labelPoNo: 'PO no',
        labelCreditMemoNo: 'Credit memo no',
        labelDueDate: 'Due date',
        labelTerms: 'Terms',
        labelAmount: 'Amount',
        labelCode: 'Code',
        labelDescription: 'Description',
        labelQuantity: 'Quantity',
        labelRate: 'Rate',
        labelTax: 'Tax',
        labelSubtotal: 'Subtotal',
        labelBalanceDue: 'Balance due',
        labelDiscount: 'Discount',
        labelNonTaxableItem: 'Non-taxtable item',
        labelPaid: 'Paid',
        labelShipping: 'Shipping',
        labelTotal: 'Total',
        labelIncludes: 'Includes',
        labelTotalAmountPaid: 'Total Amount Paid',
        labelShipDate: 'Ship Date',
        labelShipTo: 'Ship to',
        labelShipVia: 'Ship via',
        labelTrackingNo: 'Tracking no',
        labelFob: 'F.O.B',
        prefix: 'Prefix',
        prefixInvoice: 'Invoice',
        prefixEstimate: 'Estimate',
        prefixPurchaseOrder: 'Purchase Order',
        prefixCreditMemo: 'Credit Memo',
        nextNumber: 'Next Number',
        numberingBeginsAt: 'Numbering begins at',
        nextNumberInvoice: 'Invoice',
        nextNumberEstimate: 'Estimate',
        nextNumberPurchaseOrder: 'Purchase Order',
        nextNumberCreditMemo: 'Credit Memo',
        options: 'Options',
        optionTerms: 'Terms',
        optionDueDate: 'Due Date',
        optionShippingAddress: 'Shipping address',
        optionProductCode: 'Product code',
        optionQuantityAndRate: 'Quantity and rate',
        optionTax: 'Tax',
        optionAmount: 'Amount',
        optionNonTaxableItemStar: 'Non-taxable item star',
        optionTaxBreakdown: 'Tax Breakdown',
        optionPaymentHistory: 'Payment history',
        optionStamp: 'Stamp',
        optionPageNumber: 'Page Number',
        previewName: 'Robin',
        previewAddress: '726 Building St. #872',
        previewCity: 'Seattle,Washington',
        previewZip: '99999 US',
        previewDate: 'Oct 1,2019',
        previewShipName: 'Peter',
        previewShipDate: 'Oct 2,2019',
        previewShipVia: 'Federal Express',
        previewThanksMessage: "Thanks for your business! We hope you are satisfied with our work. Please remit payment within 15 days.Questions? Comments? Contact us at(111)111-1234 or email us at example@owner.com, we'll be happy to answer any questions or concerns.",
        previewSubtotal: 'Subtotal',
        previewVat: 'VAT 17.00%',
        previewPayment1: 'Payment on Oct 1, 2019',
        previewPayment2: 'Payment on Oct 2, 2019'
    },
    feedback: {
        title: 'Send Feedback',
        invalidEmailNoticePrefix: 'The email address on your account is invalid, so we were unable to contact you. Please send your feedback from a valid email address to',
        invalidEmailNoticeSuffix: 'If possible, include a screenshot of the issue; it will help us investigate and resolve it.',
        replyTip: 'After sending, please check your email for the reply.',
        content: 'Content',
        enterDescription: 'Enter a description'
    },
    createExpense: {
        title: 'Add Expense',
        description: 'Description',
        expenseDescriptionPlaceholder: 'Expense description',
        total: 'Total',
        tax: 'Tax',
        tip: 'Tip',
        expenseDate: 'Expense Date',
        merchant: 'Merchant',
        merchantPlaceholder: 'Enter merchant name',
        categoryPlaceholder: 'Select category',
        addNewCategory: 'Add new category',
        deletePhoto: 'Delete',
        addPhoto: 'Add photo',
        deleteCategory: 'delete',
        addCategory: 'Add category'
    },
    updateExpense: {
        title: 'Update Expense',
        deleteExpense: 'Delete Expense',
        confirmDeleteMsg: 'This will delete the expense. Continue?'
    },
    notFound: {
        oops: 'OOPS!',
        notFoundMsg: "We can't seem to find the page that you're looking for.",
        takeMeHome: 'Take me home'
    },
    classicPDF: {
        previewName: 'Robin',
        previewAddress: '726 Building St. #872',
        previewCity: 'Seattle,Washington',
        previewZip: '99999 US',
        previewDate: 'Oct 1,2019',
        previewDueDate: 'Nov 15,2019',
        previewShipName: 'Peter',
        previewFreeShipping: 'Free Shipping',
        previewShipDate: 'Oct 2,2019',
        previewShipVia: 'Federal Express',
        previewItem1: 'Computer',
        previewItem2: 'Phone',
        previewItem3: 'Birthday cake',
        previewTaxRate: '17%',
        nonTaxableNote: '* Indicates non-taxable item',
        thanksMessage: "Thanks for your business! We hope you are satisfied with our work. Please remit payment within 15 days.Questions? Comments? Contact us at(111)111-1234 or email us at example@owner.com, we'll be happy to answer any questions or concerns.",
        subtotal: 'Subtotal',
        vat: 'VAT 17.00%',
        payment1: 'Payment on Oct 1, 2019',
        payment2: 'Payment on Oct 2, 2019',
        balanceDue: 'Balance Due'
    }
};
